import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="agent-assignment"
export default class extends Controller {
  static targets = ["link", "fields"];
  connect() {}

  showFields() {
    this.linkTarget.classList.add("hidden");
    this.fieldsTarget.classList.remove("hidden");

    const dateField = this.fieldsTarget.querySelector("input[type='date']");
    if (dateField) {
      dateField.value = this.getCurrentDate();
    }

    const timeField = this.fieldsTarget.querySelector("input[type='time']");
    if (timeField) {
      timeField.value = this.getCurrentTime();
    }

    const firstField = this.fieldsTarget.querySelector("input");
    if (firstField) {
      firstField.focus();
    }
  }

  getCurrentDate() {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0"); // months are zero-based
    const day = String(today.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
  }

  getCurrentTime() {
    const now = new Date();
    const hours = String(now.getHours()).padStart(2, "0");
    const minutes = String(now.getMinutes()).padStart(2, "0");

    return `${hours}:${minutes}`;
  }
}
